"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCookie = exports.setCookie = exports.getCookie = void 0;
function getCookie(key) {
    if (typeof document === 'undefined') {
        return;
    }
    var cookies = document.cookie.split('; ');
    for (var _i = 0, cookies_1 = cookies; _i < cookies_1.length; _i++) {
        var cookie = cookies_1[_i];
        var _a = cookie.split('='), k = _a[0], v = _a[1];
        if (k === key) {
            return v;
        }
    }
}
exports.getCookie = getCookie;
function setCookie(key, value, expires, age) {
    if (expires === void 0) { expires = 'Mon, 01 Feb 2027 16:55:43 GMT'; }
    if (age === void 0) { age = '315576000'; }
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }
    var domain = window.location.hostname;
    document.cookie = "".concat(key, "=").concat(value, ";Path=/;Domain=").concat(domain, ";Expires=").concat(expires, ";Max-Age=").concat(age);
}
exports.setCookie = setCookie;
function deleteCookie(key) {
    if (getCookie(key)) {
        setCookie(key, '', 'Thu, 01 Jan 1970 00:00:00 UTC', '0');
    }
}
exports.deleteCookie = deleteCookie;
//# sourceMappingURL=cookies.js.map